import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../routes/Home.vue";
import Login from "../routes/Login.vue";

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            title: 'Dott. Daniele Ciceri - Personal Trainer',
            metaTags: [{
                    name: 'description',
                    content: 'Dott. Daniele Ciceri - Personal Trainer, Chinesiologo e Preparatore Atletico. Servizi di allenamento personalizzato e consulenza nutrizionale.'
                },
                {
                    property: 'og:description',
                    content: 'Dott. Daniele Ciceri - Personal Trainer, Chinesiologo e Preparatore Atletico. Servizi di allenamento personalizzato e consulenza nutrizionale.'
                }
            ]
        }
    },
    {
        path: "/login",
        name: "login",
        component: Login
    },
    {
        path: "*",
        redirect: '/'
    }
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
});

export default router;